<template>
  <Layout :removePadding="true" :onlyLogoHeader="true">
    <div
      class="text-center primary--text display font-weight-bold"
      :class="$vuetify.breakpoint.smAndDown ? 'pt-3 pb-0' : 'pt-10 pb-5'"
    >
      {{ $t("sign_up." + type + ".title") }}
      <p class="text-center primary--text font-weight-light subtitle-2 pt-2">
        {{ $t("sign_up." + type + ".subtitle") }}
      </p>
    </div>

    <div
      class="mx-10"
      :class="$vuetify.breakpoint.smAndDown ? 'mt-9' : 'mt-13'"
    >
      <v-col
        class="primary--text py-5"
        v-for="(field, i) in credentials"
        :key="i"
      >
        <v-row class="pl-3">
          {{ $t("sign_up_options." + i) }}
        </v-row>
        <v-row align="center">
          <v-text-field
            flat
            solo
            hide-details
            single-line
            v-model="credentials[i]"
            class="input-custom"
            :append-icon="i === 'tag' ? 'info_outline' : ''"
            @click:append="dialog = !dialog"
            :placeholder="
              i !== 'email' ? $t('sign_up.placeholder_example') : ''
            "
          >
          </v-text-field>
          <span v-if="formErrors" class="red--text pl-1 col-12">{{
        formErrors[i]
      }}</span>
        </v-row>
      </v-col>
    </div>

    <div class="d-flex justify-center align-center" style="height: 30px">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-checkbox 
          v-model="acceptTerms" 
          :rules="[v => !!v || $t('error.agree_terms')]"
          required
        >
          <template v-slot:label>
            <p class="text-center primary--text pt-5">
              {{ $t("sign_up.read_terms") }}
              <span class="font-weight-bold" @click="openLegal()">{{
                $t("sign_up.terms")
              }}</span>
            </p>
          </template>
        </v-checkbox>
      </v-form>
    </div>

    <div class="mt-13 mx-10">
      <v-btn
        class="px-13 py-7 mb-5 w-100 primary semi-rounded"
        style="color: var(--text-over-secondary) !important"
        outlined
        x-large
        outlined-border-width="7"
        :loading="sentRequest"
        @click="signUp()"
      >
        {{ $t("sign_up.access") }}
      </v-btn>
      <v-btn
        color="primary"
        class="px-13 py-7 w-100 semi-rounded"
        outlined
        x-large
        outlined-border-width="7"
        @click="
          $router.push({
            name: $route.params.singleType
              ? routeNames.LOGIN
              : routeNames.SELECT_SIGN_UP,
          })
        "
      >
        {{ $t("sign_up.go_back") }}
      </v-btn>
    </div>
    <TagInfoDialog v-if="this.type == 'tag'" :triggerDialog="dialog" />
    <LegalDialog ref="legalDialog" :dialogData="{primary_text: legal}" :hideIcon="true"/>
  </Layout>
</template>

<script>
import { mapState } from "vuex";
import lagalMixins from "@/mixins/StringUtils";
import Layout from "@/views/layouts/MainLayout";
import config from "@/config/app-config";
import { SignUpCredentials } from "../entities/request-bodies/SignUpCredentials";
import RedirectHandler from "@/mixins/RedirectHandler";
import TagInfoDialog from "@/components/dialogs/TagInfoDialog";
import LegalDialog from "@/components/dialogs/GenericDismissibleDialog"

export default {
  name: "SignUpType",
  props: ["routeNames", "auth"],
  mixins: [lagalMixins, RedirectHandler],
  data() {
    return {
      config: config,
      type: null,
      acceptTerms: false,
      credentials: null,
      sentRequest: false,
      formErrors: {},
      showInfo: false,
      dialog: false,
      valid: true,
    };
  },
  methods: {
    openLegal() {
      try {
        if (this.validURL(this.legal)) {
          window.open(this.legal);
        }else {
          this.$refs.legalDialog.dialog = true
        }
      } catch (error) {
        this.$refs.legalDialog.dialog = true
      }
    },
    validateTicket () {
      this.formErrors.locator = !this.credentials[this.type] ? this.$t("error.bad_request.any.required") : null
      return this.credentials[this.type]
    },  
    validateTagId() {
      if (!this.credentials[this.type]){
        this.formErrors.tag = this.$t("error.bad_request.any.required");
        return false
      }
      if (this.credentials[this.type].match(/\b[0-9A-F]{15}\b/gi)) {
        var tagId = this.credentials[this.type].slice(0, -1);
        var decimalTagId = parseInt(tagId, 16);
        var checkdigit = this.credentials[this.type].slice(-1);
        var isValid = luhn(decimalTagId.toString().concat(checkdigit));
        if (isValid) {
          return true;
        } else {
          this.formErrors.tag = this.$t(
            "error.bad_request.string.invalid_tag"
          );
          return false;
        }
      } else if (this.credentials[this.type].match(/\b[0-9A-F]{14}\b/gi)) {
        return true;
      } else {
        this.formErrors.tag = this.$t("error.bad_request.string.hex");
        return false;
      }
    },
    signUp() {    
      if (!this.$refs.form.validate()) return
      this.formErrors = {}
      const context = this;
      if (this.type === "tag" && !this.validateTagId()) return;
      if (this.type === "locator" && !this.validateTicket()) return;
      this.sentRequest = true;
      const signUpData = new SignUpCredentials(
        this.credentials.email,
        this.type === "locator" ? "TICKET" : this.type.toUpperCase(),
        this.type === "no_reference"
          ? null
          : this.type === "tag" && this.credentials[this.type].length === 15
          ? this.credentials[this.type].slice(0, -1)
          : this.credentials[this.type]
      );

      this.auth
        .signUp(context, signUpData)
        .then(() => {
          context.sentRequest = false;

          const action = this.type;
          const viewData = {
            primary_text: {
              vicon: "check_circle",
              text: "sign_up.email_send",
            },
            secondary_text: "sign_up.email_send_subtitle",
            redirectTo: "LOGIN",
          };

          this.successSignUpRedirect(action, viewData, true);
        })
        .finally(() => {
          context.sentRequest = false;
        });
    },
  },
  async created() {
    if (!this.customization.customization) {
      this.$store.dispatch("getLegalNotice", this);
    }
    this.type = this.$route.params.type;
    this.credentials = { ...this.config.SIGN_UP_FIELDS[this.type] };
    if (this.$route.query.code) {
      this.credentials[this.type] = this.$route.query.code;
    }
  },
  components: {
    Layout,
    TagInfoDialog,
    LegalDialog
  },
  computed: {
    ...mapState(["customization"]),
    legal() {
      return this.getLocalizedString(this.customization.customization.legal);
    },
    credentialsEmpty() {
      let valid = true;
      for (const credential in this.credentials) {
        if (Object.hasOwnProperty.call(this.credentials, credential)) {
          const element = this.credentials[credential];
          if (!element) {
            valid = false;
          }
        }
      }
      return valid;
    },
  },
  mounted() {
    !(function (e) {
      if ("object" == typeof exports && "undefined" != typeof module)
        module.exports = e();
      else if ("function" == typeof define && define.amd) define([], e);
      else {
        var n;
        (n =
          "undefined" != typeof window
            ? window
            : "undefined" != typeof global
            ? global
            : "undefined" != typeof self
            ? self
            : this),
          (n.luhn = e());
      }
    })(function () {
      return (function e(n, r, t) {
        function o(u, i) {
          if (!r[u]) {
            if (!n[u]) {
              var d = "function" == typeof require && require;
              if (!i && d) return d(u, !0);
              if (f) return f(u, !0);
              var l = new Error("Cannot find module '" + u + "'");
              throw ((l.code = "MODULE_NOT_FOUND"), l);
            }
            var p = (r[u] = { exports: {} });
            n[u][0].call(
              p.exports,
              function (e) {
                var r = n[u][1][e];
                return o(r ? r : e);
              },
              p,
              p.exports,
              e,
              n,
              r,
              t
            );
          }
          return r[u].exports;
        }
        for (
          var f = "function" == typeof require && require, u = 0;
          u < t.length;
          u++
        )
          o(t[u]);
        return o;
      })(
        {
          1: [
            function (e, n, r) {
              "use strict";
              Object.defineProperty(r, "__esModule", { value: !0 }),
                (r.default = (function (e) {
                  return function (n) {
                    for (var r = n ? n.length : 0, t = 1, o = 0; r--; )
                      o += (t ^= 1) ? e[n[r]] : parseInt(n[r], 10);
                    return o % 10 === 0 && o > 0;
                  };
                })([0, 2, 4, 6, 8, 1, 3, 5, 7, 9])),
                (n.exports = r.default);
            },
            {},
          ],
        },
        {},
        [1]
      )(1);
    });
  },
};
</script>

<style>
.v-input--selection-controls__input{
  display: flex;
  justify-content: center;
}
.v-input--selection-controls__input input[role="checkbox"] {
  opacity: 1 !important;
  max-width: 18px !important;
}
.theme--light.v-btn.v-btn--disabled {
  opacity: 0.5 !important;
}
</style>
